import { render, staticRenderFns } from "./NavbarItem.vue?vue&type=template&id=37a9264f&scoped=true&"
import script from "./NavbarItem.vue?vue&type=script&lang=js&"
export * from "./NavbarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItem.vue?vue&type=style&index=0&id=37a9264f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9264f",
  null
  
)

export default component.exports